import { UserManager } from "oidc-client-ts";
import { jwtDecode } from "jwt-decode";

const ORIGIN = window.location.origin;
const AUTHORITY = import.meta.env.VITE_AUTHORITY || ORIGIN;
const CLIENT_ID = import.meta.env.VITE_CLIENT_ID || "ww_mountain_admin";
const SCOPE =
  import.meta.env.VITE_SCOPE || "openid profile email roles offline_access api";
const REDIRECT = `${ORIGIN}/callback`;
const LOGOUT = `${ORIGIN}/signout-callback`;

export const oidcConfig = {
  authority: AUTHORITY,
  client_id: CLIENT_ID,
  redirect_uri: REDIRECT,
  response_type: "code",
  scope: SCOPE,
  post_logout_redirect_uri: LOGOUT,
  automaticSilentRenew: false,
  includeIdTokenInSilentRenew: true,
};

export const mgr = new UserManager(oidcConfig);

export async function renewUserSession() {
  const user = await userManager.getUser();
  if (!user?.refresh_token) {
    return null;
  }

  return userManager.signinSilent();
}

mgr.events.addUserLoaded((user) => {
  try {
    const payload = jwtDecode(user.id_token);
    const perm = payload.perm;
    const perms = Array.isArray(perm) ? perm : perm ? [perm] : [];
    localStorage.setItem("claims", JSON.stringify(perms));
  } catch (e) {
    console.error("[OIDC] failed to decode id_token", e);
  }
});

export const userManager = mgr;

userManager.events.addAccessTokenExpired(() =>
  renewUserSession().catch(console.error)
);
userManager.events.addSilentRenewError((err) =>
  console.error("Silent renew failed", err)
);
userManager.events.addUserSignedOut(() =>
  console.log("User signed out remotely")
);
